module.exports = __webpack_public_path__ + "src/img/cookies/iphones-2.33b83.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cookies/iphones-2.png
// module id = 250
// module chunks = 0